export const TIME_KEEPING_SESSION_STORAGE_KEY = 'media-manager:time-keeping:active-session-id';

export function readStoredTimeKeepingSessionId(): string | undefined {
  try {
    return localStorage.getItem(TIME_KEEPING_SESSION_STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function writeStoredTimeKeepingSessionId(id: string): void {
  try {
    localStorage.setItem(TIME_KEEPING_SESSION_STORAGE_KEY, id);
  } catch {
    // ignore quota / disabled storage
  }
}

export function clearStoredTimeKeepingSessionId(): void {
  try {
    localStorage.removeItem(TIME_KEEPING_SESSION_STORAGE_KEY);
  } catch {
    // ignore quota / disabled storage
  }
}
